/* EAS region routing. Supported IP countries retain their own market;
   unsupported locations use Uganda. Regional cookies are not proof of location. */
(() => {
  'use strict';
  const html = document.documentElement;
  const ready = result => {
    html.dataset.easRegionState = 'ready';
    html.dataset.easRegionVerified = 'true';
    html.dataset.easRegionResult = result;
    document.dispatchEvent(new CustomEvent('eas:region-ready'));
  };
  const cleanPath = location.pathname.replace(/^\/en-(?:ke|ma|tz|ug|zm|zw)(?=\/|$)/i, '') || '/';
  if (cleanPath !== location.pathname) { location.replace(cleanPath + location.search + location.hash); return; }
  const form = document.getElementById('EasAutomaticLocalization');
  const config = form?.querySelector('[data-eas-current-country]');
  if (!form || !config) { html.dataset.easRegionState = 'error'; return; }
  const current = config.dataset.easCurrentCountry;
  const supported = config.dataset.easSupportedCountries.split(',');
  const fallback = 'UG';
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const attemptKey = 'eas-region-attempt-v2';
  const choiceKey = 'eas-delivery-choice-v3';
  const returnUrl = () => {
    const url = new URL(location.href);
    url.pathname = cleanPath;
    url.searchParams.delete('variant');
    url.searchParams.delete('country');
    return url.pathname + url.search + url.hash;
  };
  function apply(target, result) {
    if (!supported.includes(target)) { html.dataset.easRegionState = 'error'; return; }
    if (target === current) { ready(result); return; }
    html.dataset.easRegionVerified = 'false';
    const attempt = read(attemptKey);
    if (attempt?.country === target && Date.now() - attempt.at < 15000) {
      html.dataset.easRegionState = 'error';
      html.dataset.easRegionResult = 'localization-retry-needed';
      return;
    }
    write(attemptKey, {country:target, at:Date.now()});
    form.elements.namedItem('country_code').value = target;
    form.elements.namedItem('return_to').value = returnUrl();
    html.dataset.easRegionState = 'switching';
    html.dataset.easRegionResult = result;
    form.submit();
  }
  html.dataset.easDeliveryChoiceAllowed = 'false';
  let manualChoice = false;
  window.EasRegion = Object.freeze({
    choose(country) {
      if (html.dataset.easDeliveryChoiceAllowed !== 'true' || html.dataset.easRegionVerified !== 'true' || !supported.includes(country)) return false;
      manualChoice = true;
      write(choiceKey, {country, at:Date.now()});
      apply(country, 'delivery-choice');
      return true;
    }
  });
  if (window.Shopify?.designMode || document.getElementById('EasEditorLocalization')) { ready('preview'); return; }
  function resolveLocation(detected, failed) {
    if (manualChoice) return;
    const local = supported.includes(detected);
    html.dataset.easDeliveryChoiceAllowed = String(!local);
    if (local) { apply(detected, 'ip-matched'); return; }
    const choice = read(choiceKey);
    if (supported.includes(choice?.country) && Date.now() - choice.at < 3600000) {
      apply(choice.country, 'delivery-choice'); return;
    }
    apply(fallback, failed ? 'location-unavailable-uganda' : 'uganda-fallback');
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  fetch('/browsing_context_suggestions.json?country[enabled]=true', {
    credentials:'same-origin', signal:controller.signal, headers:{Accept:'application/json'}
  }).then(response => {
    if (!response.ok) throw new Error('Location unavailable');
    return response.json();
  }).then(data => {
    resolveLocation(data?.detected_values?.country?.handle, false);
  }).catch(() => resolveLocation(null, true))
    .finally(() => clearTimeout(timeout));
})();
